import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { selectIsIframeMode } from '@rpt-ngrx/selectors/session.selector';
import { selectSiteState } from '@rpt-ngrx/selectors/sites.selector';

@Injectable({
    providedIn: 'root',
})
export class SitesGuard implements CanActivate {
    private sitesState = this.store.select(selectSiteState);

    constructor(
        private store: Store,
        private router: Router,
    ) {}

    canActivate(
        _next: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.store.select(selectIsIframeMode).pipe(
            switchMap((isIframe) => {
                return this.sitesState.pipe(
                    map(({ sites }) => {
                        if (sites && sites?.length === 0 && isIframe) {
                            this.router
                                .navigate(['/custom-reports/error-page'], { queryParams: { type: 'no-sites' } })
                                .catch();

                            return false;
                        }
                        return true;
                    }),
                );
            }),
        );
    }
}
